module.exports = __webpack_public_path__ + "img/hr-rock-medium-06.76620aca.png";